import { render, staticRenderFns } from "./ContentPreview.vue?vue&type=template&id=4e6f5150&scoped=true"
import script from "./ContentPreview.vue?vue&type=script&lang=js"
export * from "./ContentPreview.vue?vue&type=script&lang=js"
import style0 from "./ContentPreview.vue?vue&type=style&index=0&id=4e6f5150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f5150",
  null
  
)

export default component.exports